import { render, staticRenderFns } from "./TempConfigModuleModal.vue?vue&type=template&id=35baf75e&scoped=true"
import script from "./TempConfigModuleModal.vue?vue&type=script&lang=js"
export * from "./TempConfigModuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35baf75e",
  null
  
)

export default component.exports